import React from 'react';
import './errorBoundaryWrapper.css';

/**
 * Returns a React class component wrapper that catches rendering errors in WrappedComponent via componentDidCatch and displays a fallback error UI instead.
 *
 * Returns a class component factory (HOC) — the returned class intercepts rendering errors via componentDidCatch and shows a fallback error UI instead of the wrapped component.
 *
 * @param WrappedComponent - The React component class or function to wrap with error boundary behavior.
 */
export const errorBoundaryWrapper = (WrappedComponent:any) =>
    class extends React.Component<any,any> {
        constructor(props:any) {
            super(props);
            this.state = {
                error: null,
                errorInfo: null
            } as any;
        }

        componentDidCatch(error:any, errorInfo:any) {
            // Catch errors in any components below and re-render with error message
            this.setState({
                error,
                errorInfo
            });
            // You can also log error messages to an error reporting service here
        }

        render() {
            if (this.state.errorInfo) {
                // Error path
                return (
                    <div className='error-boundary-wrapper'>
                        <h2>Something went wrong!</h2>
                        <details style={{ whiteSpace: 'pre-wrap' }}>
                            {this.state.error && this.state.error.toString()}
                            <br />
                            {this.state.errorInfo.componentStack}
                        </details>
                    </div>
                );
            }
            // Normally, just render children
            return <WrappedComponent {...this.props} />;
        }
    };
errorBoundaryWrapper.displayName = 'errorBoundaryWrapper';
export default errorBoundaryWrapper;
